import { render, staticRenderFns } from "./StandardBtnsTemplate.vue?vue&type=template&id=d5672d18&scoped=true&"
import script from "./StandardBtnsTemplate.vue?vue&type=script&lang=js&"
export * from "./StandardBtnsTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5672d18",
  null
  
)

export default component.exports